@if (isVisible) {
  <div class="container-out" (click)="close()"></div>
}

@if (isVisible) {
  <div class="container-info slide-bottom" [style.position]="isMenu ? 'fixed' : 'sticky'">
    @if (openManager) {
      <div class="title">
        <h2><b>Assinatura digital</b></h2>
        <span class="subtitle">
          Selecione o provedor responsável pelo certificado para ativar a assinatura digital da sua conta
        </span>
        <form class="form" [formGroup]="model" (ngSubmit)="submit()">
          <mat-radio-group formControlName="selectedProvider">
            <div class="row">
              <!-- usar slide toggles para controlar o provider selecionado -->
              <div class="col-2 col-md-2">
                <mat-radio-button [value]="signatureProvidersEnum.safeID"
                (change)="selectProvider($event)"></mat-radio-button>
              </div>
              <div class="col-10 col-md-10">
                <div class="provider" [id]="signatureProvidersEnum.safeID" (click)="openComponent(signatureProvidersEnum.safeID)">
                  <div class="provider-info">
                    <img src="/assets/images/signature-providers/safe-id/safeid-logo.png">
                    <mat-icon matTooltip="{{descriptionSafeIDStatusIcon}}">{{safeIDStatusIcon}}</mat-icon>
                  </div>
                  <mat-icon>chevron_right</mat-icon>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-2 col-md-2">
                <mat-radio-button [value]="signatureProvidersEnum.techCert"
                (change)="selectProvider($event)"></mat-radio-button>
              </div>
              <div class="col-10 col-md-10">
                <div class="provider" [id]="signatureProvidersEnum.techCert" (click)="openComponent(signatureProvidersEnum.techCert)">
                  <div class="provider-info">
                    <img src="/assets/images/signature-providers/tech-cert/techcert-logo.png">
                    <mat-icon matTooltip="{{descriptionTechCertStatusIcon}}">{{techCertStatusIcon}}</mat-icon>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-2 col-md-2">
                <mat-radio-button [value]="signatureProvidersEnum.vidaaS"
                (change)="selectProvider($event)"></mat-radio-button>
              </div>
              <div class="col-10 col-md-10">
                <div class="provider" [id]="signatureProvidersEnum.vidaaS" (click)="openComponent(signatureProvidersEnum.vidaaS)">
                  <div class="provider-info">
                    <img src="/assets/images/signature-providers/vidaaS/logo-vidaas.png">
                    <mat-icon matTooltip="{{descriptionVidaaSStatusIcon}}">{{vidaaSStatusIcon}}</mat-icon>
                  </div>
                  <mat-icon>chevron_right</mat-icon>
                </div>
              </div>
            </div>
          </mat-radio-group>
        </form>
      </div>
    }
    @if (openSafeID) {
      <app-safeID-authenticator [isMenu]="isMenu" (goBack)="reset($event)" (credentialsRequest)="submit($event)"
        (setStatusIcon)="setStatusIcon($event, signatureProvidersEnum.safeID)"
      ></app-safeID-authenticator>
    }
    @if (openVidaaS) {
      <app-vidaas-authenticator [isMenu]="isMenu" (goBack)="reset($event)" (credentialsRequest)="submit($event)"
        (setStatusIcon)="setStatusIcon($event, signatureProvidersEnum.vidaaS)"
      ></app-vidaas-authenticator>
    }
    @if (!isMenu && !openSafeID && !isLoading && !openVidaaS) {
      <div class="button-container">
        <a class="link-button" (click)="cancelSigning()">Seguir sem
        assinatura</a>
      </div>
    }
  </div>
}